var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgErrorIconinline = function SvgErrorIconinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AF3535",
    d: "M10 0a10 10 0 1 0 10 10A10.02 10.02 0 0 0 10 0m3.625 12.529a.78.78 0 0 1 0 1.096.79.79 0 0 1-1.096 0L10 11.086l-2.529 2.539a.79.79 0 0 1-1.096 0 .78.78 0 0 1 0-1.096L8.913 10 6.375 7.471a.779.779 0 0 1 1.096-1.096L10 8.913l2.529-2.538a.779.779 0 0 1 1.096 1.096L11.086 10z"
  })));
};
export default SvgErrorIconinline;